import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from 'src/app/auth.service';
import { SettingsService } from 'src/app/settings.service';
declare var $: any;
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';
import { ThemingService } from 'src/app/theming.service';


@Component({
  selector: 'app-settings-modal',
  templateUrl: './settings-modal.component.html',
  styleUrls: ['./settings-modal.component.scss']
})
export class SettingsModalComponent implements OnInit {
  shopSubscription: any;
  shopLogsActive: boolean = false;
  permissions: any = {};
  hasAccess!: boolean;
  userRole!: string;
  activeTab: string = 'currentPlan';
  showSidebar: boolean = true; 
  constructor(
    private settingsService: SettingsService,
    public authService: AuthService,
    private router: Router,
    private translate: TranslateService,
    private themingService: ThemingService
  ) {
    translate.setDefaultLang('es');
    translate.use('es');
  }

  async ngOnInit(): Promise<void> {
    this.shopSubscription = this.themingService.shopTheming[0].shopSubscription;
    this.shopLogsActive = Object.values(
      this.shopSubscription?.shopLogsAllow ?? {}
    ).some((value: any) => value === 1);
    this.loadPermissionsAndRole()
    this.syncActiveTabWithRoute(this.router.url);
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => this.syncActiveTabWithRoute(event.urlAfterRedirects));
  $('#settingsModal').on('show.bs.modal', () => {
    document.querySelector('app-side-bar')?.classList.add('d-none');
  });
  $('#settingsModal').on('hidden.bs.modal', () => {
    document.querySelector('app-side-bar')?.classList.remove('d-none');
  });
  }
  toggleSidebar(): void {
    this.showSidebar = !this.showSidebar;
  }

  selectSettingsTab(event: Event): void {
    const link = (event.target as HTMLElement).closest<HTMLAnchorElement>(
      'a[data-bs-toggle="pill"]'
    );
    const target = link?.getAttribute('href');
    if (target?.startsWith('#')) {
      this.activeTab = target.substring(1);
    }
  }

  activateShopCompanies(): void {
    this.settingsService.setListingShopCompanies();
    this.activeTab = 'stepShopCompanies';
  }

  async loadPermissionsAndRole(): Promise<void> {
    try {
      this.permissions = await this.authService.getUserPermissions();
      this.userRole = await this.authService.getUserRole();
      if (this.userRole === 'Owner' || this.userRole === 'Admin' || this.permissions.userRoles === true) {
        this.hasAccess = true;
      } else {
        this.hasAccess = false;
      }
      if (
        this.permissions.generalInfo &&
        !this.router.url.startsWith('/settings/shop-companies')
      ) {
        this.activeTab = 'step1';
      }

    } catch (error) {
      console.error('Error al obtener permisos o rol del usuario:', error);
    }
  }

  private syncActiveTabWithRoute(url: string): void {
    if (url.startsWith('/settings/shop-companies')) {
      this.activeTab = 'stepShopCompanies';
      const editMatch = url.match(
        /^\/settings\/shop-companies\/(\d+)\/edit(?:[?#].*)?$/
      );
      if (editMatch) {
        this.settingsService.setEditingShopCompany(editMatch[1]);
      } else if (/^\/settings\/shop-companies\/create(?:[?#].*)?$/.test(url)) {
        this.settingsService.setCreatingShopCompany();
      } else {
        this.settingsService.setListingShopCompanies();
      }
      return;
    }
    if (url.startsWith('/settings/theming')) {
      this.activeTab = 'step5';
      return;
    }
    if (url.startsWith('/settings/current-plan')) {
      this.activeTab = 'currentPlan';
    }
  }

  ngOnDestroy() {
    $('#settingsModal').modal('hide');
  }

  closeModal() {
    $('#settingsModal').modal('hide');
  }

  

  /**
   * This function returns a boolean value that is stored in the settingsService
   * @returns A boolean value.
   */
  getListingUsers(): boolean {
    return this.settingsService.getListingUsers();
  }

  /**
   * This function returns the value of the editingOwner property of the settingsService
   * @returns A boolean value.
   */
  getEditingOwner(): boolean {
    return this.settingsService.getEditingOwner();
  }

  /**
   * If the user is editing a user, return true
   * @returns A boolean value.
   */
  isEditingUser(): boolean {
    return this.settingsService.isEditingUser();
  }

  /**
   * It returns the editing user from the settings service
   * @returns The editing user.
   */
  getEditingUser(): string {
    return this.settingsService.getEditingUser();
  }

  /**
   * The function calls the setListingUsers() function in the settingsService
   */
  setListingUsers(): void {
    this.settingsService.setListingUsers();
  }

  /**
   * It returns a boolean value that is stored in the settingsService
   * @returns A boolean value.
   */
  getCreatingUser(): boolean {
    return this.settingsService.getCreatingUser();
  }

  /**
   * It sets the creatingUser property of the settingsService to true
   */
  setCreatingUser(): void {
    this.settingsService.setCreatingUser();
  }

  /**
   * This function returns a boolean value that is stored in the settingsService
   * @returns A boolean value.
   */
  getListingCategories(): boolean {
    return this.settingsService.getListingCategories();
  }

  getListingSubCategories(): boolean {
    return this.settingsService.getListingSubCategories();
  }

  /**
   * If the user is editing a category, return true
   * @returns A boolean value.
   */
  isEditingCategory(): boolean {
    return this.settingsService.isEditingCategory();
  }

  isEditingSubCategory(): boolean {
    return this.settingsService.isEditingSubCategory();
  }

  /**
   * It returns the editing category from the settings service
   * @returns The editing category.
   */
  getEditingCategory(): string {
    return this.settingsService.getEditingCategory();
  }

  getEditingSubCategory(): string {
    return this.settingsService.getEditingSubCategory();
  }

  /**
   * The function calls the setListingCategories() function in the settingsService
   */
  setListingCategories(): void {
    this.settingsService.setListingCategories();
  }

  /**
   * It returns a boolean value that is stored in the settingsService
   * @returns A boolean value.
   */
  getCreatingCategory(): boolean {
    return this.settingsService.getCreatingCategory();
  }

  getCreatingSubCategory(): boolean {
    return this.settingsService.getCreatingSubCategory();
  }

  /**
   * It sets the creatingCategory property of the settingsService to true
   */
  setCreatingCategory(): void {
    this.settingsService.setCreatingCategory();
  }

  /* COLLECTIONS */
  getListingCollections(): boolean {
    return this.settingsService.getListingCollections();
  }

  isEditingCollection(): boolean {
    return this.settingsService.isEditingCollection();
  }

  getEditingCollection(): string {
    return this.settingsService.getEditingCollection();
  }

  setListingCollections(): void {
    this.settingsService.setListingCollections();
  }

  getCreatingCollection(): boolean {
    return this.settingsService.getCreatingCollection();
  }

  setCreatingCollection(): void {
    return this.settingsService.setCreatingCollection();
  }

  /* SUBSCRIPTIONS */
  getListingSubscriptions(): boolean {
    return this.settingsService.getListingSubscriptions();
  }

  isEditingSubscription(): boolean {
    return this.settingsService.isEditingSubscription();
  }

  getEditingSubscription(): string {
    return this.settingsService.getEditingSubscription();
  }

  setListingSubscriptions(): void {
    this.settingsService.setListingSubscriptions();
  }

  getCreatingSubscription(): boolean {
    return this.settingsService.getCreatingSubscription();
  }

  setCreatingSubscriptio(): void {
    return this.settingsService.setCreatingSubscription();
  }

  /* SUPPLIERS */
  getListingSuppliers(): boolean {
    return this.settingsService.getListingSuppliers();
  }

  isEditingSupplier(): boolean {
    return this.settingsService.isEditingSupplier();
  }

  getEditingSupplier(): string {
    return this.settingsService.getEditingSupplier();
  }

  setListingSuppliers(): void {
    this.settingsService.setListingSuppliers();
  }

  getCreatingSupplier(): boolean {
    return this.settingsService.getCreatingSupplier();
  }

  setCreatingSupplier(): void {
    return this.settingsService.setCreatingSupplier();
  }

  /* SHOP POINTS */
  getListingShopPoints(): boolean {
    return this.settingsService.getListingShopPoints();
  }

  isEditingShopPoint(): boolean {
    return this.settingsService.isEditingShopPoint();
  }

  getEditingShopPoint(): string {
    return this.settingsService.getEditingShopPoint();
  }

  setListingShopPoints(): void {
    this.settingsService.setListingShopPoints();
  }

  getCreatingShopPoint(): boolean {
    return this.settingsService.getCreatingShopPoint();
  }

  setCreatingShopPoint(): void {
    return this.settingsService.setCreatingShopPoint();
  }

  /* PAYMENT METHOD */
  getListingPaymentMethods(): boolean {
    return this.settingsService.getListingPaymentMethods();
  }

  isEditingPaymentMethod(): boolean {
    return this.settingsService.isEditingPaymentMethod();
  }

  getEditingPaymentMethod(): string {
    return this.settingsService.getEditingPaymentMethod();
  }

  setListingPaymentMethods(): void {
    this.settingsService.setListingPaymentMethods();
  }

  getCreatingPaymentMethod(): boolean {
    return this.settingsService.getCreatingPaymentMethod();
  }

  setCreatingPaymentMethod(): void {
    return this.settingsService.setCreatingPaymentMethod();
  }

  getListingShopCompanies(): boolean {
    return this.settingsService.getListingShopCompanies();
  }

  getCreatingShopCompany(): boolean {
    return this.settingsService.getCreatingShopCompany();
  }

  isEditingShopCompany(): boolean {
    return this.settingsService.isEditingShopCompany();
  }

  getEditingShopCompany(): string {
    return this.settingsService.getEditingShopCompany();
  }

  setListingShopCompanies(): void {
    this.settingsService.setListingShopCompanies();
  }

    /* FAQs */
    getListingFAQs(): boolean {
      return this.settingsService.getListingFAQs();
    }

}
